export const ADD_CLIENT="ADD_CLIENT";
export const CLIENT_DETAILS="CLIENT_DETAILS";
export const CLIENT_DATA="CLIENT_DATA";
export const ADD_NOTICE="ADD_NOTICE";
export const NOTICE_DETAILS="NOTICE_DETAILS";
export const NOTICE_DATA="NOTICE_DATA";
export const ADD_PROJECT_DATA="ADD_PROJECT_DATA";
export const ADD_CUSTOMER_DATA="ADD_CUSTOMER_DATA";
export const CUSTOMER_LIST= "CUSTOMER_LIST";
export const ADD_DESIGNATION_DATA= "ADD_DESIGNATION_DATA";
export const EMAIL_DATA= "EMAIL_DATA";
export const INSERT_REPORT_DATA= "INSERT_REPORT_DATA";
export const REPORT_ISSUE_LIST= "REPORT_ISSUE_LIST";
export const REPORT_CLOSED_LIST= "REPORT_CLOSED_LIST";
export const NOTIFICATION_LIST= "NOTIFICATION_LIST";
export const NOTIFICATION_UPDATE= "NOTIFICATION_UPDATE";
export const NOTIFICATION_CLEAR= "NOTIFICATION_CLEAR";
export const PENDING_ISSUE_LIST= "PENDING_ISSUE_LIST";
export const ASSIGN_REPORT= "ASSIGN_REPORT";
export const CLOSE_REPORT= "CLOSE_REPORT";
export const HOLIDAY_LIST = "HOLIDAY_LIST";
export const ADD_HOLIDAY_DATA = "ADD_HOLIDAY_DATA";
export const PROJECT_ACCESS_LIST = "PROJECT_ACCESS_LIST";
export const ADD_TEAM_MEMBER = "ADD_TEAM_MEMBER";
export const RELEASE_TEAM_MEMBER = "RELEASE_TEAM_MEMBER";

